import { Collection } from "@/types/documents/documents.types";

// Helper function to get collection info (name and whether it's smart) for a file
export const getFileCollectionInfoHelper = (
  fileId: string,
  allCollections: Collection[]
): { name: string; isSmart: boolean } | null => {
    for (const collection of allCollections) {
      const collectionId = collection.id || collection.collectionId;
      if (collectionId && collection.files && fileId in collection.files) {
        return {
          name: collection.name || collection.title || 'Unnamed Collection',
          isSmart: collection.isSmartCollection || false,
        };
      }
    }
    return null;
};
